var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H13C13.5304 15 14.0391 14.7893 14.4142 14.4142C14.7893 14.0391 15 13.5304 15 13C15 12.4696 14.7893 11.9609 14.4142 11.5858C14.0391 11.2107 13.5304 11 13 11H10C9.4 11 8.9 11.2 8.6 11.6L3 17",
    stroke: "#545354",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.0003L8.6 19.6003C8.9 19.2003 9.4 19.0003 10 19.0003H14C15.1 19.0003 16.1 18.6003 16.8 17.8003L21.4 13.4003C21.7859 13.0356 22.0111 12.5326 22.0261 12.0018C22.0411 11.4711 21.8447 10.9562 21.48 10.5703C21.1153 10.1844 20.6123 9.95916 20.0816 9.94416C19.5508 9.92916 19.0359 10.1256 18.65 10.4903L14.45 14.3903",
    stroke: "#545354",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16L8 22",
    stroke: "#545354",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0016 11.8996C17.6032 11.8996 18.9016 10.6012 18.9016 8.99961C18.9016 7.39798 17.6032 6.09961 16.0016 6.09961C14.3999 6.09961 13.1016 7.39798 13.1016 8.99961C13.1016 10.6012 14.3999 11.8996 16.0016 11.8996Z",
    stroke: "#545354",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C7.65685 8 9 6.65685 9 5C9 3.34315 7.65685 2 6 2C4.34315 2 3 3.34315 3 5C3 6.65685 4.34315 8 6 8Z",
    stroke: "#545354",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHand);
export default __webpack_public_path__ + "static/media/icon-hand.9fab4c65f6e0ed34c5bfc2b2e1f322ee.svg";
export { ForwardRef as ReactComponent };